import React from 'react';
import styled from 'styled-components';
import PlusIcon24 from '@honeybook/icons/dist/icons/Plus24';
import PlusIcon16 from '@honeybook/icons/dist/icons/Plus16';
import colors from '@honeybook/hbui/dist/styles/colors';
import HBNewLogo from '@honeybook/hbui/dist/components/HBNewLogo/HBNewLogo';
import HBMediaElement from '@honeybook/hbui/dist/components/HBMediaElement/HBMediaElement';
import { useWindowSize } from '@honeybook/hbui/dist/components/common/useWindowSize';

const AdobeSignupLogo = () => {
    const { isMediumUp } = useWindowSize();

    return (
        <AdobeLogoContainer>
            <AcrobatLogo
                path={
                    isMediumUp
                        ? '/logos_icons/adobe_acrobat_logo_icon'
                        : '/logos_icons/adobe_acrobat_logo_icon_mobile'
                }
                width={isMediumUp ? 110 : 22}
                flagsToRemove={['quality', 'flags', 'fetchFormat']}
            />
            {isMediumUp ? (
                <PlusIconBig color={colors.neutral900} />
            ) : (
                <PlusIconSmall color={colors.neutral900} />
            )}
            <HBNewLogo type={isMediumUp ? 'default' : 'short'} size="sm" />
        </AdobeLogoContainer>
    );
};

export default AdobeSignupLogo;

const AdobeLogoContainer = styled.div`
    display: flex;
    align-items: center;
    justify-content: center;
    margin-bottom: 20px;
    position: relative;
    top: 4px;
`;

const AcrobatLogo = styled(HBMediaElement)`
    display: flex;
`;

const PlusIconBig = styled(PlusIcon16)`
    margin: 0 8px;
    line-height: 0;
`;

const PlusIconSmall = styled(PlusIcon24)`
    margin: 0 10px;
    line-height: 0;
`;
